import React, { useCallback } from 'react';
import { IconButton, IconButtonTheme, IconButtonSize, Panel, PanelTheme } from '@apply/components';
import { faBell, faUserCircle, faTrashCan, faEdit } from '@fortawesome/free-regular-svg-icons';

export const IconButtonDemo: React.FC<{}> = ({}) => {
    const buttonClick: React.MouseEventHandler = useCallback((event) => {
        alert(event.currentTarget.id + ' clicked.');
    }, []);

    return (
        <div style={{ marginTop: '0px', marginBottom: '20px' }}>
            <h2>Icon Button :</h2>
            <br />
            <IconButton
                id='White Bell Button With Count'
                theme={IconButtonTheme.White}
                handleClick={buttonClick}
                size={IconButtonSize.Medium}
                icon={faBell}
                bubbleNumber={25}
            />
            <br />
            <IconButton
                id='White Profile Button With No Count'
                theme={IconButtonTheme.White}
                handleClick={buttonClick}
                size={IconButtonSize.Medium}
                icon={faUserCircle}
                hint='View Profile'
            />
            <br />
            <IconButton
                id='White Profile Button Disabled'
                theme={IconButtonTheme.White}
                handleClick={buttonClick}
                size={IconButtonSize.Medium}
                icon={faUserCircle}
                disabled={true}
            />
            <br />
            <IconButton
                id='Transparent Bell Button With Count'
                theme={IconButtonTheme.Transparent}
                handleClick={buttonClick}
                size={IconButtonSize.Medium}
                icon={faBell}
                bubbleNumber={13}
            />
            <br />
            <IconButton
                id='Transparent Profile Button With No Count'
                theme={IconButtonTheme.Transparent}
                handleClick={buttonClick}
                size={IconButtonSize.Medium}
                icon={faUserCircle}
                hint='View Profile'
            />
            <br />
            <IconButton
                id='Transparent Profile Button Disabled'
                theme={IconButtonTheme.Transparent}
                handleClick={buttonClick}
                size={IconButtonSize.Medium}
                icon={faUserCircle}
                disabled={true}
            />
            <br />
            <Panel
                theme={PanelTheme.White}
                width='40px'
            >
                <IconButton
                    id='Red Trash Button With Count'
                    theme={IconButtonTheme.Red}
                    handleClick={buttonClick}
                    size={IconButtonSize.Small}
                    icon={faTrashCan}
                    bubbleNumber={9}
                />
                <br />
                <IconButton
                    id='Red Trash Button With No Count'
                    theme={IconButtonTheme.Red}
                    handleClick={buttonClick}
                    size={IconButtonSize.Small}
                    icon={faTrashCan}
                    hint='Delete Item'
                />
                <br />
                <IconButton
                    id='Disabled Red Trash Button With No Count'
                    theme={IconButtonTheme.Red}
                    handleClick={buttonClick}
                    size={IconButtonSize.Small}
                    icon={faTrashCan}
                    hint='Delete Item'
                    disabled={true}
                />
                <br />
                <IconButton
                    id='Blue Edit Button With Count'
                    theme={IconButtonTheme.Blue}
                    handleClick={buttonClick}
                    size={IconButtonSize.Small}
                    icon={faEdit}
                    bubbleNumber={3}
                />
                <br />
                <IconButton
                    id='Blue Edit Button With No Count'
                    theme={IconButtonTheme.Blue}
                    handleClick={buttonClick}
                    size={IconButtonSize.Small}
                    icon={faEdit}
                />
                <br />
                <IconButton
                    id='Disabled Blue Edit Button With No Count'
                    theme={IconButtonTheme.Blue}
                    handleClick={buttonClick}
                    size={IconButtonSize.Small}
                    icon={faEdit}
                    disabled={true}
                />
            </Panel>
        </div>
    );
};
